import {
  getCategoryColors,
  getCategoryListColors,
  getCategoryLabelColors,
} from "./utils/themeColors";

// export const API_URL = "http://192.168.0.102:4000/graphql";
// export const API_URL = "http://localhost:4000/graphql";
// export const IMAGES_API_URL = "http://localhost:4000/public/";
export const API_URL = `https://api.theautochef.com/graphql`;
export const IMAGES_API_URL = `https://api.theautochef.com/public/`;
export const IMAGES_UPLOAD_API_URL = `https://api.theautochef.com/graphql/upload/recipe/`;
export const PROFILE_UPLOAD_API_URL = `https://api.theautochef.com/graphql/upload/user/`;
// export const KITCHEN_API_URL = "http://192.168.1.100:5401/";
// export const KITCHEN_API_URL = "http://192.168.1.100:5401/";
// export const UTENSIL_CHECK_API_URL = "http://192.168.1.100:5403/";
export const KITCHEN_API_URL = "http://localhost:5401/";
export const UTENSIL_CHECK_API_URL = "http://localhost:5403/";
export const SOCKET_TIMEOUT = "3000000";
export const WAITING_RECIPE_DURATION = 100;
// export const KITCHEN_API_URL = "ws://192.168.1.100:5481/";
export const SECURITY_CHECKS = {
  CHIMNEY_CHECK: "chimney_check",
  HEAT_CHECK: "heat_check",
  PRESSURE_CHECK: "pressure_check",
  STEAM_CHECK: "steam_check",
  WATER_CHECK: "water_check",
  STIR_CHECK: "stir_check",
  WAIT_CHECK: "wait_check",
  SAUTE_CHECK: "saute",
  LID_CHECK: "lidcheck",
  LID_OPEN_CHECK: "lid-open-check",
  KITCHEN_READY: "kitchen_ready",
  NUTRIPOT_CHECK: "nutripot_check",
};
export const ingredientTasksMap = {
  "Dispense Grain": "Dispenser Box",
  "Dispense Spice": "Dispenser Box",
  "Pour Manual Station Bowl": "Bowl",
  "Pour Manual Station Cup": "Cup",
  "Add Oil": "Oil Bottle",
  "Add Sauce/Paste": "Sauce Bottle",
  "Soak Grain": "Soak Position",
};
export const getRecipeImage = (recipe_image) => {
  if (recipe_image) {
    const isString =
      typeof recipe_image === "string"
        ? JSON.parse(recipe_image)
        : recipe_image;
    Array.isArray(isString)
      ? (recipe_image = isString[0])
      : (recipe_image = isString);
    console.log(recipe_image);
    return recipe_image;
  }
  return "/placeholder-16x9.png";
};

// Convert time values to proper format
export const formatTime = (seconds) => {
  if (!seconds) return "N/A";
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins} min${mins !== 1 ? "s" : ""}${secs ? ` ${secs} sec` : ""}`;
};

export const ingredientChipTasksMap = {
  "Dispense Grain": "Grain Box",
  "Dispense Spice": "Spice Box",
  "Pour Manual Station Bowl": "Bowl",
  "Pour Manual Station Cup": "Cup",
  "Add Oil": "Oil Bottle",
  "Add Sauce/Paste": "Sauce Bottle",
  "Add Water": "Water Tap",
  "Soak Grain": "Soak Position",
};

export function validateTaskType(type) {
  const boxCounts = {
    choose_grains: "grain",
    choose_soaks: "grain",
    choose_spices: "spice",
    choose_bowl: "manualbowl",
    choose_cup: "manualcup",
    choose_oil: "oil",
    choose_paste: "paste",
  };
  return boxCounts[type] || 0;
}

// Helper function to get theme-based colors for categories
export const getThemeColors = (theme) => ({
  categoryColors: getCategoryColors(theme),
  categoryListColors: getCategoryListColors(theme),
  categoryLabelColors: getCategoryLabelColors(theme),
});

// Legacy constants for backward compatibility (deprecated - use getThemeColors instead)
export const categoryColors = {
  "Grain Box": "#FFC107",
  "Spice Box": "#FF5722",
  "Manual Bowl Station": "#4CAF50",
  "Manual Cup Station": "#4CAF50",
  "Oil Bottle": "#2196F3",
  "Paste Bottle": "#9C27B0",
  "Water Tap": "#00BCD4",
  "Soak Position": "#00796b",
};
export const categoryListColors = {
  "Dispense Grain": "#FFC107",
  "Dispense Spice": "#FF5722",
  "Pour Manual Station Bowl": "#4CAF50",
  "Pour Manual Station Cup": "#4CAF50",
  "Add Oil": "#2196F3",
  "Add Sauce/Paste": "#9C27B0",
  "Add Water": "#00BCD4",
  "Soak Grain": "#00796b",
};

export const categoryLabelColors = {
  "Grain Item": "#FFB300",
  "Spice Item": "#FF7043",
  Bowl: "#66BB6A",
  Cup: "#66BB6A",
  "Oil Bottle": "#42A5F5",
  "Sauce Bottle": "#BA68C8",
  "Water Tap": "#26C6DA",
  "Soaking Area": "#80CBC4",
};

export const categoryLabels = {
  "Dispense Grain": "Grain Item",
  "Dispense Spice": "Spice Item",
  "Pour Manual Station Bowl": "Bowl",
  "Pour Manual Station Cup": "Cup",
  "Add Oil": "Oil Bottle",
  "Add Sauce/Paste": "Sauce Bottle",
  "Add Water": "Water Tap",
  "Soak Grain": "Soaking Area",
};
export function getBoxCount(type) {
  const boxCounts = {
    choose_grains: 12,
    choose_spices: 10,
    choose_soaks: 1,
    choose_oil: 2,
    choose_paste: 3,
    choose_water: 1,
    choose_bowl: 6,
    choose_cup: 4,
  };
  return boxCounts[type] || 0;
}

export const validTaskTypes = [
  "choose_stir",
  "choose_seconds",
  "choose_minutes",
  "choose_grains",
  "choose_soaks",
  "choose_spices",
  "choose_oil",
  "choose_paste",
  "choose_water",
  "choose_bowl",
  "choose_cup",
];

export const validActionTaskTypes = [
  "choose_stir",
  "choose_seconds",
  "choose_minutes",
];
export const validIngredientTaskTypes = [
  "choose_grains",
  "choose_spices",
  "choose_oil",
  "choose_paste",
  "choose_water",
  "choose_bowl",
  "choose_cup",
  "choose_soaks",
];
